import { Icon } from '@nazka/nazka.mapframe.components'
import { useRef, useState, useEffect } from 'react'

import './icon-btn-hor.styl'

function IconBtnHor(props) {
  const {
    noText, inactive, disabled, children, iconProps = {}, badge, onClick, placeholder = '',
    min, max, step, inputIncluded, value, unit, onChange, isLoading,
  } = props
  const inputRef = useRef(null)
  const spanRef = useRef(null)
  const [inputWidth, setInputWidth] = useState(1)

  useEffect(() => {
    if (spanRef.current && inputRef.current) {
      spanRef.current.textContent = value || placeholder || ''
      const measuredWidth = spanRef.current.offsetWidth + 30
      if (Math.abs(measuredWidth - inputWidth) >= 5) {
        setInputWidth(measuredWidth)
      }
    }
  }, [value, placeholder, inputWidth])

  return (
    <button
      className={
        `icon-btn-hor`
        + `${noText ? ' icon-btn-hor--no-text' : ''}`
        + `${inactive ? ' icon-btn-hor--inactive' : ''}`
        + `${disabled || isLoading ? ' icon-btn-hor--disabled' : ''}`
        + `${isLoading ? ' is-loading' : ''}`
      }
      type="button"
      onClick={(event) => {
        event.stopPropagation()
        if (!disabled && !isLoading && onClick) onClick(event)
      }}
    >
      <span className="icon-btn-hor__icon">
        <Icon {...iconProps} />
        {badge}
      </span>
      <span className={`icon-btn-hor__text ${inputIncluded ? 'icon-btn-hor__text--input' : ''}`}>
        <span>{children}</span>
        {inputIncluded
          && (
            <>
              <span>
                <input
                  ref={inputRef}
                  onClick={e => !inactive && !disabled && !isLoading && e.stopPropagation()}
                  type="number"
                  style={{
                    pointerEvents: inactive || disabled || isLoading ? 'none' : 'auto',
                    width: inputWidth,
                    minWidth: '25px',
                    font: 'inherit',
                    padding: '2px 4px',
                  }}
                  min={min}
                  max={max}
                  step={step}
                  value={value}
                  onChange={e => onChange(e.target.value)}
                  className="icon-btn-hor__text__input"
                />
                <span
                  ref={spanRef}
                  style={{
                    position: 'absolute',
                    visibility: 'hidden',
                    height: 0,
                    overflow: 'hidden',
                    whiteSpace: 'pre',
                    font: 'inherit',
                  }}
                />
              </span>
              <span>{unit}</span>
            </>
          )}
      </span>
    </button>
  )
}

export default IconBtnHor
